import { render, staticRenderFns } from "./my-order-history-navigation.vue?vue&type=template&id=36cf0171&scoped=true&"
import script from "./my-order-history-navigation.vue?vue&type=script&lang=js&"
export * from "./my-order-history-navigation.vue?vue&type=script&lang=js&"
import style0 from "./my-order-history-navigation.vue?vue&type=style&index=0&id=36cf0171&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf0171",
  null
  
)

export default component.exports